import storageSession from "redux-persist/lib/storage/session";
import { PersistConfig } from "redux-persist";

// Shared helper for creating a sessionStorage-backed redux-persist config.
// Use this for any page-level filter/UI state that should survive page
// navigation and refreshes during a login session, but should NOT survive
// closing the browser tab/window (unlike the localStorage-backed "user" slice).
//
// Each page's filter slice should pass its own unique `key` so the persisted
// values remain distinct per page (e.g. "usersListFilter", "someOtherPageFilter").
export function createSessionPersistConfig<S>(key: string): PersistConfig<S> {
	return {
		key,
		storage: storageSession,
	};
}
